export const typography = {
  fontFamily: ['Sarabun'].join(','),
  h1: {
    fontWeight: 700,
    lineHeight: '62.4px',
    fontSize: '48px',

    '@media (max-width: 600px)': {
      lineHeight: '52px',
      fontSize: '40px',
    },
  },
  h2: {
    fontWeight: 700,
    lineHeight: '52px',
    fontSize: '40px',

    '@media (max-width: 700px)': {
      lineHeight: '41.6px',
      fontSize: '32px',
    },
  },
  h3: {
    fontWeight: 700,
    lineHeight: '41.6px',
    fontSize: '32px',
  },
  h4: {
    fontWeight: 700,
    lineHeight: '36.4px',
    fontSize: '28px',
  },
  h5: {
    fontWeight: 700,
    lineHeight: '28.6px',
    fontSize: '22px',
  },
  body1: {
    fontWeight: 'normal',
    fontSize: '18px',
    lineHeight: '23.4px',
  },
  body2: {
    fontWeight: 'normal',
    fontSize: '14px',
    lineHeight: '18.2px',
  },
};
